@if (epcotEnabled) {
    <div class="team-grouping-container">
        <ds-segmented-control [fullWidth]="true" [activeOption]="selectedId?.toString()" (activeOptionChange)="onTeamGroupingChange($event, true)">
            @for (item of teamGroupingOptions; track item.id) {
                <ds-segmented-option [name]="item.id.toString()" [title]="item.name" />
            }
        </ds-segmented-control>
    </div>
} @else {
    <ms-scroll-adapter [scrollItems]="teamGroupingOptions">
        <ul>
            @for (item of teamGroupingOptions; track item.id) {
                <li class="team-grouping-item" [class.selected]="selectedId === item.id" (click)="onTeamGroupingChange(item.id, true)">
                    <span class="team-grouping-text">
                        <span>{{ item.name }}</span>
                    </span>
                </li>
            }
        </ul>
    </ms-scroll-adapter>
}
